<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.pageRegistrierkasseDE.title') }}
    </portal>
    <card v-if="receipts != null"
          :title="$t('admin.pageRegistrierkasseDE.card.receipts')"
          :collapsed="receiptsCollapsed"
          cols="12"
          card-type="collapsible">
      <hm-card-inner v-if="!activated">
        <hm-col cols="6">
          <span class="warning-text col-12">Bitte schließen Sie evtl. vorhanden offenen Geschäftsfälle ab, bevor Sie die TSE aktivieren.</span>
          <hm-button class="btn--green"
                     icon-left="eye"
                     @click="$router.push({ name: 'enableKassenSichV' })">
            Zu den offenen Geschäftsfällen
          </hm-button>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner v-if="!isNil(config)">
        <hm-input :disabled="true"
                  v-model="config.queueId"
                  label="QueueId/CashBoxIdentification"
                  name="queueId"
                  cols="12 6@hd start-1" />
      </hm-card-inner>
      <hm-card-inner :full-size="true">
        <hm-table :hover="true"
                  min-width="400px"
                  columns="5"
                  grid-template-columns="2fr 2fr 1fr 4fr 1fr">
          <template slot="table-head">
            <div class="hm-table__th">{{ $t('admin.pageRegistrierkasseDE.receipt.type') }}</div>
            <div class="hm-table__th">{{ $t('admin.pageRegistrierkasseDE.receipt.cashBox') }}</div>
            <div class="hm-table__th">{{ $t('admin.pageRegistrierkasseDE.receipt.businessDate') }}</div>
            <div class="hm-table__th">{{ $t('admin.pageRegistrierkasseDE.receipt.dateTime') }}</div>
            <div class="hm-table__th">&nbsp;</div>
          </template>
          <template v-for="receipt in receipts">
            <div :key="`${receipt.id}-flag`" class="hm-table__td">
              <template v-for="flag in receipt.receipts[0].flags">{{ flag }} </template>
              <template v-if="receipt.receipts[0].flags.includes('StartReceipt')">
                ({{ receipt.receipts[0].businessDate | toDate }})
              </template>
            </div>
            <div :key="`${receipt.id}-cashBox`" class="hm-table__td">{{ receipt.receipts[0].cashDeskId }}</div>
            <div :key="`${receipt.id}-businessDate`" class="hm-table__td">{{ receipt.receipts[0].businessDate | toDate }}</div>
            <div :key="`${receipt.id}-dateTime`" class="hm-table__td">{{ receipt.receipts[0].receiptDateTime | toLocalDateTime }}</div>
            <div :key="`${receipt.id}-actions`" class="hm-table__td hm-table__td--icon">
              <span v-if="receipt.receipts[0].flags.includes('StartReceipt')" class="quick-action-button" @click="downloadStartReceipt()">
                <icon icon="download" />
              </span>
              <span class="quick-action-button" @click="printReceipt(receipt, 0)">
                <icon icon="printer" />
              </span>
            </div>
          </template>
        </hm-table>
      </hm-card-inner>
    </card>
    <template v-for="year in years">
      <card v-if="receiptsByYear[year] != null"
            :key="year"
            :title="`${year}`"
            cols="12"
            card-type="collapsible">
        <hm-card-inner :full-size="true" :key="`${year}-${receiptKey}`">
          <hm-table :hover="true"
                    min-width="400px"
                    columns="3"
                    grid-template-columns="2fr 4fr 1fr">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('admin.pageRegistrierkasseDE.receipt.type') }}</div>
              <div class="hm-table__th">{{ $t('admin.pageRegistrierkasseDE.receipt.dateTime') }}</div>
              <div class="hm-table__th">&nbsp;</div>
            </template>
            <template v-for="receipt in receiptsByYear[year]">
              <template v-if="!isNil(receipt.receipts) && receipt.receipts.length > 0">
                <div :key="`${receipt.id}-flag`" class="hm-table__td">
                  <template v-for="flag in receipt.receipts[0].flags">{{ flag }} </template>
                  <template v-if="receipt.receipts[0].flags.includes('DayReceipt')">
                    ({{ receipt.receipts[0].additionalFields.EU_DE_DATE | toDate }})
                  </template>
                  <template v-if="receipt.receipts[0].flags.includes('MonthReceipt')">
                    ({{ receipt.receipts[0].additionalFields.EU_DE_YEAR }}/{{ receipt.receipts[0].additionalFields.EU_DE_MONTH }})
                  </template>
                  <template v-if="receipt.receipts[0].flags.includes('YearReceipt')">
                    ({{ receipt.receipts[0].additionalFields.EU_DE_YEAR }})
                  </template>
                </div>
                <div :key="`${receipt.id}-dateTime`" class="hm-table__td">{{ receipt.receipts[0].receiptDateTime | toLocalDateTime }}</div>
                <div :key="`${receipt.id}-actions`" class="hm-table__td hm-table__td--icon">
                  <span class="quick-action-button" @click="printReceipt(receipt, 0)">
                    <icon icon="printer" />
                  </span>
                </div>
              </template>
            </template>
          </hm-table>
        </hm-card-inner>
      </card>
    </template>
    <hm-floating-buttons v-if="receipts != null">
      <hm-floating-button v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                          :throttle="5000"
                          :label="$t('admin.pageRegistrierkasseDE.actions.outOfOperation')"
                          icon="close"
                          color="red"
                          @click="confirmOutOfOperation('outOfOperation')" />
      <hm-floating-button v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                          :throttle="5000"
                          :label="$t('admin.pageRegistrierkasseDE.actions.initiateSCUSwitch')"
                          icon="close"
                          color="red"
                          @click="confirmSCUSwitch('initiateSCUSwitch')" />
      <hm-floating-button v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                          :throttle="5000"
                          :label="$t('admin.pageRegistrierkasseDE.actions.finishSCUSwitch')"
                          icon="close"
                          color="red"
                          @click="confirmSCUSwitch('finishSCUSwitch')" />
      <hm-floating-button v-if="hasRole('ROLE_SYSADMIN') && hasReceiptsForActiveQueue"
                          :throttle="5000"
                          :label="$t('admin.pageRegistrierkasseDE.actions.autoClosing')"
                          icon="cal"
                          color="orange"
                          @click="receiptAction('autoClosing')" />
      <hm-floating-button v-if="hasRole('ROLE_SYSADMIN') && hasReceiptsForActiveQueue"
                          :throttle="5000"
                          :label="$t('admin.pageRegistrierkasseDE.actions.createDayReceipt')"
                          icon="per-night"
                          color="orange"
                          @click="receiptAction('createDayReceipt')" />
      <hm-floating-button v-if="hasLicense('EU_DE_Registrierkasse')"
                          label="Downloads"
                          icon="download"
                          color="gray">
        <hm-floating-child-button
          :throttle="15000"
          label="Status"
          color="orange"
          icon="download"
          @click="journalStatus()"/>
        <hm-floating-child-button
          :throttle="15000"
          label="DSFinV-K"
          color="orange"
          icon="download"
          @click="journalDSFinVK()"/>
        <hm-floating-child-button
          :throttle="15000"
          label="Middleware TAR"
          color="orange"
          icon="download"
          @click="journalMiddlewareTar()"/>
        <hm-floating-child-button
          :throttle="15000"
          label="TSE TAR"
          color="orange"
          icon="download"
          @click="journalTseTar()"/>
      </hm-floating-button>
      <hm-floating-button v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                          :throttle="50000"
                          :label="$t('admin.pageRegistrierkasseDE.actions.restartCashBox')"
                          icon="refresh"
                          color="orange"
                          @click="restartCashBox()" />
      <hm-floating-button v-if="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') && !hasReceiptsForActiveQueue"
                          :throttle="15000"
                          :label="$t('admin.pageRegistrierkasseDE.actions.createStartReceipt')"
                          icon="plus"
                          color="orange"
                          @click="receiptAction('createStartReceipt')" />
      <hm-floating-button v-if="hasReceiptsForActiveQueue"
                          :throttle="5000"
                          :label="$t('admin.pageRegistrierkasseDE.actions.createNullReceipt')"
                          icon="plus"
                          color="blue"
                          @click="receiptAction('createNullReceipt')" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { cloneDeep, groupBy, isEmpty, isNil, sortBy, reverse, keyBy, uniq } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Reports from '@/lib/reports';
import { TimelineMax, TweenMax } from 'gsap';
import UpdateHotelSettingsMixin from '../../../mixins/UpdateHotelSettingsMixin';
import TimerMixin from '../../../mixins/TimerMixin';
import uuid from 'uuid';
import HmFloatingButton from '../../lib/inputs/HmFloatingButton';
import HmFloatingChildButton from '../../lib/inputs/HmFloatingChildButton';
import HmCardInner from '../../lib/layout/HmCardInner';

export default {
  name: 'PageRegistrierkasseDE',
  components: { HmCardInner, HmFloatingChildButton, HmFloatingButton },
  mixins: [HotelmeisterMixin, SaveWatchMixin, TimerMixin],

  data() {
    return {
      activated: false,
      config: null,
      receipts: null,
      receiptsByYear: {},
      certificate: null,
      receiptsCollapsed: false,
      receiptKey: uuid.v4(),
    };
  },

  computed: {
    startReceipt: function () {
      if (this.receipts == null) return null;
      return this.receipts.find(it => it.receipts[0].flags.includes('StartReceipt'));
    },
    startReceiptPdfLink: function () {
      if (this.startReceipt == null) return null;

      return window.getOldUIPath(
        this.hotelSettings.tenant.subdomain,
        this.hotelSettings.hotel.id,
        `/rest/ui/backend/hotel/${this.$route.params.hotelId}/print/receipt?parentId=${this.hotelSettings.hotel.id}&receiptHolderId=${this.startReceipt.id}&receiptSeq=${0}&outputType=pdf`,
        window.getToken(this.$route.params.hotelId),
        null,
        true,
      );
    },
    years: function () {
      const ret = [];
      for (let i = this.$moment().year(); i >= 2020; i--) {
        ret.push(i);
      }
      return ret;
    },
    cashDeskIds: function () {
      const ret = [
        isNil(this.config) ? null : this.config.queueId,
        ...uniq(this.receipts.map(it => it.receipts[0].cashDeskId)),
      ];

      return uniq(ret);
    },
    hasReceiptsForActiveQueue() {
      if (isNil(this.config)) return false;
      return this.receipts.map(it => it.receipts[0].cashDeskId).includes(this.config.queueId);
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
    this.setInterval(this.updateReceipts, 15000);
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    isNil,
    printHTML(url) {
      this.$serviceBus.$emit('printHTML', url);
    },
    printReceipt(receipt, seq) {
      const receiptHolderId = receipt.id;
      let parentId = this.hotelSettings.hotel.id;

      if (!isEmpty(receipt.receipts[seq].additionalFields.EU_DE_YEAR)) {
        parentId = `${parentId}::${receipt.receipts[seq].additionalFields.EU_DE_YEAR}`;
      }

      this.printHTML(
        window.getOldUIPath(
          this.hotelSettings.tenant.subdomain,
          this.hotelSettings.hotel.id,
          `/rest/ui/backend/hotel/${this.$route.params.hotelId}/print/receipt?parentId=${parentId}&receiptHolderId=${receiptHolderId}&receiptSeq=${seq}`,
          window.getToken(this.$route.params.hotelId),
          null,
          true,
        ),
      );
    },
    loadData() {
      this.updateReceipts();
      this.loadConfig();
    },
    loadConfig() {
      this.axios.get(this.serviceUrls.interfaces.fiskaltrustDE.config(this, null))
        .then((response) => {
          if (isNil(this.config)) {
            this.config = response.data.data;
          }
        });
    },
    updateReceipts() {
      this.years.forEach((i) => {
        this.axios.get(this.serviceUrls.registrierkasse.de.listReceiptsByYear(this, i))
          .then((response) => {
            this.receiptsByYear[i] = reverse(response.data.data);
            if (this.receiptsByYear[i] == null) {
              this.$set(this.receiptsByYear, i, []);
              // this.receiptsByYear[i] = [];
            }
            this.receiptKey = uuid.v4();
          });
      });

      this.axios.get(this.serviceUrls.registrierkasse.de.listReceipts(this))
        .then((response) => {
          this.receipts = reverse(response.data.data);
          if (this.receipts == null) {
            this.receipts = [];
          }

          this.$nextTick(() => {
            if (!isEmpty(this.startReceipt)) {
              this.activated = true;
            }
          });
        });
    },
    confirmSCUSwitch(action) {
      this.showConfirmModal(
        'Are you sure you would like to switch the SCU? This operation can not be undone once it has been started.',
        () => {
          this.receiptAction(action);
        },
      );
    },
    confirmOutOfOperation(action) {
      this.showConfirmModal(
        'Disabling the cash desk is a permanent action and can not be undone. Do you want to proceed?',
        () => {
          this.receiptAction(action);
        },
      );
    },
    receiptAction(action) {
      this.axios.post(this.serviceUrls.registrierkasse.de[action](this))
        .then((response) => {
          this.showSuccessMessage();
          this.receiptsCollapsed = false;
          this.updateReceipts();
          this.setTimeout(this.updateReceipts, 2500);
          this.setTimeout(this.updateReceipts, 5000);
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    downloadStartReceipt() {
      window.open(this.startReceiptPdfLink, '_blank');
    },
    journalStatus() {
      this.axios.post(this.serviceUrls.interfaces.fiskaltrustDE.status(this), {})
        .then((response) => {
          window.open(response.data.data.url, '_blank');
          this.showSuccessMessage();
        })
        .catch((error) => {
          this.showMessages(error.response);
          this.showErrorMessage('');
        });
    },
    journalTseTar() {
      this.axios.post(this.serviceUrls.interfaces.fiskaltrustDE.tseTar(this), {})
        .then((response) => {
          window.open(response.data.data.url, '_blank');
          this.showSuccessMessage();
        })
        .catch((error) => {
          this.showMessages(error.response);
          this.showErrorMessage('');
        });
    },
    journalMiddlewareTar() {
      this.axios.post(this.serviceUrls.interfaces.fiskaltrustDE.middlewareTar(this), {})
        .then((response) => {
          window.open(response.data.data.url, '_blank');
          this.showSuccessMessage();
        })
        .catch((error) => {
          this.showMessages(error.response);
          this.showErrorMessage('');
        });
    },
    journalDSFinVK() {
      this.axios.post(this.serviceUrls.interfaces.fiskaltrustDE.DSFinVK(this), {})
        .then((response) => {
          window.open(response.data.data.url, '_blank');
          this.showSuccessMessage();
        })
        .catch((error) => {
          this.showMessages(error.response);
          this.showErrorMessage('');
        });
    },
    restartCashBox() {
      this.axios.post(this.serviceUrls.interfaces.fiskaltrustDE.restart(this), {})
        .then((response) => {
          this.showSuccessMessage();
        })
        .catch((error) => {
          this.showMessages(error.response);
          this.showErrorMessage('');
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageRegistrierkasseDE.vue